// extracted by mini-css-extract-plugin
export default {"topicCard__topicCard":"TopicCard_topicCard__topicCard__ppY4V","topicCard__iconContainer":"TopicCard_topicCard__iconContainer__tqO1g"};